import * as types from '@/main'
const state = {
    navigationTitle : '',
  messageNum: 80 //这个属性在全局无处不在 html取值方式为{{ $store.state.messageNum }} js取值方式为this.$store.state.myName 由于我们将其抽出进行模块化 因此取值为$store.state.模块名称.messageNum 方法类的不变
}


const mutations = {
    [types.UPDATE_TITLE](state,title){
        Object.assign(state, { ...payload })
        console.log(state.navigationTitle)
    },
  // 这里专注修改state里的数据 但是代码必须是同步执行 这里的方法用大写命名 是因为vue是这样建议的阿
  NUMADD(state,param) {
    state.messageNum ++
    // 在组件中 通过在方法中加入代码this.$store.commit('NUMADD')执行state数据的改变 如果需要传入参数则为this.$store.commit('NUMADD',实参)并且mutations方法中写入形参
    // 除了上述方法外，也可通过map来进行数据修改：
    // 先在组件中进行引入import { mapMutations} from 'vuex' 在组件的methods直接写以下两种代码
    // 第一种<div @click="myEvent"></div>：
    // ...mapMutations({
    //     myEvent: 'NUMADD'
    // })
    // 第二种(直接将NUMADD作为事件绑定到元素上)<div @click="NUMADD(传参直接写在这)"></div>：
    // ...mapMutations(['NUMADD'])
    // 注：在vuex中的mutations和actions的方法中，文档一般将参数称之为载荷
  }
}


const actions = {
    saveTitle({commit, dispatch}, payload) {
        commit(types.UPDATE_TITLE, payload)
    },
  // 这里可以执行异步请求 但是不能直接操作state 在html中想操作state则需要执行this.$store.dispatch('asyncNumAdd')
  // 也可以使用简便的方法触发asyncNumAdd 同mutations中的map 但是mapMutations要改成mapActions 其余一致
  asyncNumAdd({commit}) {
    // 无传参
    commit('NUMADD')
  },
  asyncNumAddParam({commit},num) {
    // 可传参
    commit('NUMADD',num)
  }
}


const getters = {
    localTitle: state => {
        return { ...state }
    },
  // 派生属性(类似计算属性) html取值方式为{{$store.getters.方法名}}
  formatMessageNum(state) {
    if (state.messageNum > 99) {
      return '99+'
    } else {
      return state.messageNum
    }
  }
}


export default {
  state,
  mutations,
  actions,
  getters
}


